<template>
  <div style="height: 100%; overflow: auto">
    <div>
      <h1
        style="
          margin: 17pt 0pt 16.5pt;
          orphans: 0;
          page-break-after: avoid;
          page-break-inside: avoid;
          text-align: center;
          widows: 0;
        "
      >
        <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >供销平台</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >隐私政策</span
        >
      </h1>
      <p style="margin: 0pt">
        <span style="font-family: 宋体; font-size: 10.5pt">更新日期：【</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >2024</span
        ><span style="font-family: 宋体; font-size: 10.5pt">】年</span
        ><span style="font-family: 宋体; font-size: 10.5pt">【</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">7</span
        ><span style="font-family: 宋体; font-size: 10.5pt">】</span
        ><span style="font-family: 宋体; font-size: 10.5pt">月</span
        ><span style="font-family: 宋体; font-size: 10.5pt">【</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >15</span
        ><span style="font-family: 宋体; font-size: 10.5pt">】</span
        ><span style="font-family: 宋体; font-size: 10.5pt">日</span>
      </p>
      <p style="margin: 0pt">
        <span style="font-family: 宋体; font-size: 10.5pt">生效日期：【</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >2024</span
        ><span style="font-family: 宋体; font-size: 10.5pt">】年</span
        ><span style="font-family: 宋体; font-size: 10.5pt">【</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">7</span
        ><span style="font-family: 宋体; font-size: 10.5pt">】</span
        ><span style="font-family: 宋体; font-size: 10.5pt">月</span
        ><span style="font-family: 宋体; font-size: 10.5pt">【</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >15</span
        ><span style="font-family: 宋体; font-size: 10.5pt">】</span
        ><span style="font-family: 宋体; font-size: 10.5pt">日</span>
      </p>
      <p style="margin: 0pt">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >&#xa0;</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt"
          >北京掌上先机网络科技有限公司</span
        ><span style="font-family: 宋体; font-size: 10.5pt">及关联公司</span
        ><span style="font-family: 宋体; font-size: 10.5pt">（以下称</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >“我们”，或“慧策｜旺店通”</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >）尊重您的隐私权以及个人信息保护权。</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >我们会遵循合法、正当、必要和诚信的原则处理您的个人信息。</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >我们制定本隐私政策并希望提示您了解下述内容，以便作出适当选择。</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt"
          >本隐私政策适用于</span
        ><span style="font-family: 宋体; font-size: 10.5pt">供销平台</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >产品及服务，包括</span
        ><span style="font-family: 宋体; font-size: 10.5pt">供销平台</span
        ><span style="font-family: 宋体; font-size: 10.5pt">各版本</span
        ><span style="font-family: 宋体; font-size: 10.5pt">网页</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >端以及其他由我们提供且适用本隐私政策的所有产品及服务（</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >包括微信小程序“慧策供销平台”，</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >在本隐私政策中统称为</span
        ><span style="font-family: 宋体; font-size: 10.5pt">“本服务”或“</span
        ><span style="font-family: 宋体; font-size: 10.5pt">供销平台</span
        ><span style="font-family: 宋体; font-size: 10.5pt">”</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >）。本隐私政策不适用于其他第三方向您提供的服务，您在选择使用第三方服务前应充分了解第三方服务的产品功能及隐私保护政策，再选择是否使用相应功能或服务。</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span style="font-family: 宋体; font-size: 12pt; font-weight: bold"
          >定义</span
        >
      </p>
      <p
        style="
          margin: 5pt 0pt 5pt 22pt;
          text-align: justify;
          text-indent: -22pt;
        "
      >
        <span style="font-family: Wingdings; font-size: 10.5pt"></span
        ><span style="font: 7pt 'Times New Roman'"
          >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >旺店通产品，指北京掌上先机网络科技有限公司及关联公司运营的</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >ERP</span
        ><span style="font-family: 宋体; font-size: 10.5pt">旗舰版、</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >ERP</span
        ><span style="font-family: 宋体; font-size: 10.5pt">企业版、</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">Y</span
        ><span style="font-family: 宋体; font-size: 10.5pt">计划（极速版</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >ERP</span
        ><span style="font-family: 宋体; font-size: 10.5pt">）、</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">E</span
        ><span style="font-family: 宋体; font-size: 10.5pt">快帮、</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >WMS</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >的电脑客户端应用程序以及其他与之相关的产品及服务（</span
        ><a name="_Hlk170841226"
          ><span style="font-family: 宋体; font-size: 10.5pt">包括旺店助手</span
          ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
            >App</span
          ><span style="font-family: 宋体; font-size: 10.5pt">、</span
          ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
            >PDA</span
          ></a
        ><span style="font-family: 宋体; font-size: 10.5pt">等）。</span>
      </p>
      <p
        style="
          margin: 5pt 0pt 5pt 22pt;
          text-align: justify;
          text-indent: -22pt;
        "
      >
        <span style="font-family: Wingdings; font-size: 10.5pt"></span
        ><span style="font: 7pt 'Times New Roman'"
          >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span style="font-family: 宋体; font-size: 10.5pt">企业用户</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >，指购买本服务，通过授权用户注册本服务账号，搭建组织架构并享有管理权限的法人或其他组织</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >，包括已经注册了旺店通产品的企业用户（即同时购买旺店通</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >ERP</span
        ><span style="font-family: 宋体; font-size: 10.5pt">旗舰版或者</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >ERP</span
        ><span style="font-family: 宋体; font-size: 10.5pt">企业版、</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">Y</span
        ><span style="font-family: 宋体; font-size: 10.5pt">计划（极速版</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >ERP</span
        ><span style="font-family: 宋体; font-size: 10.5pt">）、</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">E</span
        ><span style="font-family: 宋体; font-size: 10.5pt">快帮、</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >WMS</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >产品，以及供销平台服务）以及未注册旺店通产品的企业用户（即仅购买供销平台服务）。根据企业用户业务内容，企业用户可以进一步分为“供应商企业用户”以及“分销商企业用户”</span
        ><span style="font-family: 宋体; font-size: 10.5pt">。</span>
      </p>
      <p
        style="
          margin: 5pt 0pt 5pt 22pt;
          text-align: justify;
          text-indent: -22pt;
        "
      >
        <span style="font-family: Wingdings; font-size: 10.5pt"></span
        ><span style="font: 7pt 'Times New Roman'"
          >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >授权用户，包括旺店通产品</span
        ><span style="font-family: 宋体; font-size: 10.5pt">授权用户</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >和非旺店通产品授权用户。旺店通产品</span
        ><span style="font-family: 宋体; font-size: 10.5pt">授权用户指被</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >已注册旺店通产品的企业用户</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >授权或邀请加入企业用户在本服务中搭建的组织架构，并使用本服务的自然人（通常为</span
        ><span style="font-family: 宋体; font-size: 10.5pt">企业用户</span
        ><span style="font-family: 宋体; font-size: 10.5pt">的员工）。</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >非旺店通产品授权用户指未注册旺店通产品、仅使用供销平台的企业用户</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >授权或邀请加入企业用户在本服务中搭建的组织架构，并使用本服务的自然人（通常为</span
        ><span style="font-family: 宋体; font-size: 10.5pt">企业用户</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >的员工）。其中经</span
        ><span style="font-family: 宋体; font-size: 10.5pt">企业用户</span
        ><span style="font-family: 宋体; font-size: 10.5pt">指定，代</span
        ><span style="font-family: 宋体; font-size: 10.5pt">企业用户</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >配置本服务、行使后台管理权限的自然人称为管理员（为免歧义，本隐私政策中称</span
        ><span style="font-family: 宋体; font-size: 10.5pt">为“</span
        ><span style="font-family: 宋体; font-size: 10.5pt">管理员用户</span
        ><span style="font-family: 宋体; font-size: 10.5pt">”</span
        ><span style="font-family: 宋体; font-size: 10.5pt">）。</span
        ><span style="font-family: 宋体; font-size: 10.5pt">管理员用户</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >可以邀请其他授权用户使用本服务。</span
        >
      </p>
      <p
        style="
          margin: 5pt 0pt 5pt 22pt;
          text-align: justify;
          text-indent: -22pt;
        "
      >
        <span style="font-family: Wingdings; font-size: 10.5pt"></span
        ><span style="font: 7pt 'Times New Roman'"
          >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >企业联系人，指企业用户的供应商或者其他合作企业的联系人，例如</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >分销商联系人、卖家、售后退货联系人、货主联系人、云仓申请人和仓主、仓库联系人</span
        ><span style="font-family: 宋体; font-size: 10.5pt">等。</span>
      </p>
      <p
        style="
          margin: 5pt 0pt 5pt 22pt;
          text-align: justify;
          text-indent: -22pt;
        "
      >
        <span style="font-family: Wingdings; font-size: 10.5pt"></span
        ><span style="font: 7pt 'Times New Roman'"
          >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span style="font-family: 宋体; font-size: 10.5pt">授权用户、</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >企业联系人统称为</span
        ><span style="font-family: 宋体; font-size: 10.5pt">“您”</span
        ><span style="font-family: 宋体; font-size: 10.5pt">。</span>
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt; font-weight: normal"
          >下文将帮您详细了解我们如何收集、使用、存储、转移（如适用）与保护您的个人信息，并且帮您了解查询、复制、删除、更正、撤回授权个人信息的方式。本政策与您使用我们的服务关系密切，我们建议您仔细阅读并理解本隐私政策全部内容，作出您认为适当的选择，其中，</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >有关您个人信息权益的重要内容我们已用加粗形式提示，请特别关注。</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >1.</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >本服务如何收集和使用个人信息</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >2.</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >我们如何使用</span
        ><span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >Cookie</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >和同类技术</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >3</span
        ><span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >.</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >数据使用过程中涉及的合作方以及转移、公开个人信息</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >4</span
        ><span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >.</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >我们如何存储个人信息</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >5</span
        ><span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >.</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >我们如何保护个人信息的安全</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >6</span
        ><span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >.</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >管理您的个人信息</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >7</span
        ><span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >.</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >隐私政策的修订和通知</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >8</span
        ><span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >.</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >联系我们</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >9.</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >未成年人保护</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 12pt;
            font-weight: bold;
          "
          >1.</span
        ><span style="font-family: 宋体; font-size: 12pt; font-weight: bold"
          >本服务如何收集和使用个人信息</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt"
          >为了向企业用户提供本服务、满足企业用户</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >供应及分销商品业务</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >管理需要、维护本服务的正常安全运行，本服务会按照如下目的与方式，收集您在注册、使用本服务时主动提供、授权提供的个人信息，以及您使用本服务时产生的个人信息：</span
        >
      </p>
      <p style="margin: 5pt 0pt 5pt 21pt; text-indent: -21pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >1.1</span
        ><span style="font: 7pt 'Times New Roman'"
          >&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >账号服务</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt"
          >针对购买旺店通产品的企业用户，我们会自动为其授权用户配置本服务的登录账号，旺店通产品授权用户可通过旺店通产品账号（即手机号）及接收的验证码登录本服务</span
        ><span style="font-family: 宋体; font-size: 10.5pt">。</span>
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt"
          >未购买我们旺店通产品的企业用户也可注册本服务账号，此时需要向我们提供授权用户的手机号。针对非旺店通产品授权用户，在您注册本服务账号后，我们会为您同步开通分销业务，分销业务所需收集的个人信息请见第</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >1.7.1</span
        ><span style="font-family: 宋体; font-size: 10.5pt">节。</span>
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >企业用户</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >及</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >管理员用户</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >使用此功能授权我们收集员工的个人信息时，应当确保</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >企业用户</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >已经获得其本人的知情同意。</span
        >
      </p>
      <p style="margin: 5pt 0pt 5pt 21pt; text-indent: -21pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >1.2</span
        ><span style="font: 7pt 'Times New Roman'"
          >&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >运营与安全运行</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span style="font-family: 宋体; font-size: 10.5pt"
          >为了保障软件与服务的安全运行、运营的质量及效率，我们会收集您的</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >IP</span
        ><span style="font-family: 宋体; font-size: 10.5pt">地址</span
        ><span style="font-family: 宋体; font-size: 10.5pt">和浏览记录</span
        ><span style="font-family: 宋体; font-size: 10.5pt">。</span>
      </p>
      <p style="margin: 5pt 0pt 5pt 21pt; text-indent: -21pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >1.3</span
        ><span style="font: 7pt 'Times New Roman'"
          >&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >售后与客服</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span style="font-family: 宋体; font-size: 10.5pt"
          >当您通过供销平台联系客服寻求帮助时，我们的售后人员将针对您提出的产品问题进行咨询和技术支持。在此过程中，我们将收集您的昵称、姓名、电话号码、用户等级、用户</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >ID</span
        ><span style="font-family: 宋体; font-size: 10.5pt">以及</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >VIP</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >级别以校验您的用户身份，并会自动在客服系统中为您生成默认头像和性别。</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span style="font-family: 宋体; font-size: 10.5pt"
          >为便于与您联系、尽快帮助您解决问题或记录相关问题的处理方案及结果，我们可能会保存您与客服沟通记录，包括您的满意度评价。</span
        >
      </p>
      <p style="margin: 5pt 0pt 5pt 21pt; text-indent: -21pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >1.4</span
        ><span style="font: 7pt 'Times New Roman'"
          >&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >设备权限调用</span
        >
      </p>
      <p style="margin: 5pt 0pt; padding-left: 22pt; text-indent: -22pt">
        <ins
          style="
            -aw-revision-author: '墨＆Kitty';
            -aw-revision-datetime: '2024-07-10T21:23:00';
          "
          ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
            >1.4.1</span
          ></ins
        >
        <span style="font-family: 宋体; font-size: 10.5pt"
          >当您使用“慧策供销平台”小程序时，如果您需要保存小程序中的图片到本地相册，此时我们会申请</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >相册（仅写入）权限</span
        ><span style="font-family: 宋体; font-size: 10.5pt">。</span>
      </p>
      <p style="margin: 5pt 0pt; padding-left: 22pt; text-indent: -22pt">
        <ins
          style="
            -aw-revision-author: '墨＆Kitty';
            -aw-revision-datetime: '2024-07-10T21:23:00';
          "
          ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
            >1.4.2</span
          ></ins
        >
        <span style="font-family: 宋体; font-size: 10.5pt"
          >当您使用“慧策供销平台”小程序时，为了实现您可以快速输入内容，我们会申请</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >剪切板权限</span
        ><span style="font-family: 宋体; font-size: 10.5pt">。</span>
      </p>
      <p style="margin: 5pt 10.5pt 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt"
          >您可以自行决定是否开启</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">/</span
        ><span style="font-family: 宋体; font-size: 10.5pt">关闭各项权限。</span
        ><a name="_Hlk170808738"
          ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
            >请您注意，您开启权限即代表您授权我们收集和使用相关个人信息来为您提供对应的服务；您一旦关闭权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务，但这不会影响您正常使用其他功能或服务。</span
          ></a
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。</span
        >
      </p>
      <p style="margin: 5pt 0pt 5pt 21pt; text-indent: -21pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >1.5</span
        ><span style="font: 7pt 'Times New Roman'"
          >&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >收集、使用个人信息目的变更</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt"
          >为了能够为您提供更好的服务，我们会不时更新</span
        ><span style="font-family: 宋体; font-size: 10.5pt">供销平台</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >的功能和提供的服务。原则上，当新功能或服务与我们当前提供的功能或服务相关时，收集与使用的个人信息将与原处理目的具有直接或合理关联。在与原处理目的无直接或合理关联的场景下，我们收集、使用您的个人信息，会再次按照法律法规的要求以页面提示、交互流程、协议确认等合理的方式另行向您告知说明，并征得您的同意。</span
        >
      </p>
      <p style="margin: 5pt 0pt 5pt 21pt; text-indent: -21pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >1.6</span
        ><span style="font: 7pt 'Times New Roman'"
          >&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >征得授权同意的例外</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt"
          >请您理解，在下列情形中，根据法律法规及相关国家标准，我们收集和使用您的个人信息无需征得您的授权同意：</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">a.</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >与我们履行法律法规规定的义务相关的；</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">b.</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >与国家安全、国防安全直接相关的；</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">c.</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >与公共安全、公共卫生、重大公共利益直接相关的；</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">d.</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >与犯罪侦查、起诉、审判和判决执行等直接相关的；</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">e.</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">f.</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >所收集的您的个人信息是您自行向社会公众公开的；</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">g.</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">h.</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >根据您的要求签订或履行合同所必需的；</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">i</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">.</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >用于维护软件及相关服务的安全稳定运行所必需的，例如发现、处置软件及相关服务的故障；</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">j.</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >为合法的新闻报道所必需的；</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">k.</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">l.</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >法律法规规定的其他情形。</span
        >
      </p>
      <p style="margin: 5pt 0pt 5pt 21pt; text-indent: -21pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >1.7</span
        ><span style="font: 7pt 'Times New Roman'"
          >&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >企业用户作为个人信息处理者的情形</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span style="font-family: 宋体; font-size: 10.5pt; font-weight: normal"
          >我们会根据企业用户的指示及我们与企业用户之间的协议，协助授权用户处理以下</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: normal"
          >授权用户或者企业联系人的</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: normal"
          >个人信息</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: normal"
          >。</span
        ><a name="_Hlk170843326"
          ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
            >授权用户填写下述</span
          ></a
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >分销商联系人、卖家、售后退货联系人、货主</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >联系人</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >、云仓申请</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >人</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >和仓主、仓库</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >联系人</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >的个人信息时，应当确保已经获得相关个人的知情同意（包括单独同意，如需）或其他符合中国法律要求的合法性基础。</span
        >
      </p>
      <p
        style="
          margin: 15.6pt 0pt 15.6pt 22.1pt;
          text-align: justify;
          text-indent: -22.1pt;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >1.7.1</span
        ><span style="font: 7pt 'Times New Roman'"> </span
        ><span style="font-family: 宋体; font-size: 10.5pt">当授权用户</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >开通分销商业务功能时，我们会收集分销商注册用户姓名、分销商联系人手机号码、分销商联系人固定电话号、分销商联系人邮箱、卖家地址信息，以支持分销商信息展示以及相关业务联系。如您为非旺店通产品授权用户，我们为您自动开通分销商业务功能。</span
        >
      </p>
      <p
        style="
          margin: 15.6pt 0pt 15.6pt 22.1pt;
          text-align: justify;
          text-indent: -22.1pt;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >1.7.2</span
        ><span style="font: 7pt 'Times New Roman'"> </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >当分销商企业用户的授权用户申请与供应商建立合作关系时，我们会收集分销商联系人姓名、分销商申请合作联系地址、分销商联系人手机号码，以支持对分销商感兴趣的供应商进行合作联系。</span
        >
      </p>
      <p
        style="
          margin: 15.6pt 0pt 15.6pt 22.1pt;
          text-align: justify;
          text-indent: -22.1pt;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >1.7.3</span
        ><span style="font: 7pt 'Times New Roman'"> </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >当供应商企业用户的授权用户完善名片时，我们会收集供应商联系人姓名、供应商联系人手机号、供应商联系人微信账号、售后退货联系人姓名、售后退货联系电话、发件人地址，以便于对于该企业用户感兴趣的商户取得联系。</span
        >
      </p>
      <p
        style="
          margin: 15.6pt 0pt 15.6pt 22.1pt;
          text-align: justify;
          text-indent: -22.1pt;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >1.7.4</span
        ><span style="font: 7pt 'Times New Roman'"> </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >当授权用户寻找仓库时，我们会收集货主姓名、货主电话号码，以实现发布仓库需求。</span
        >
      </p>
      <p
        style="
          margin: 15.6pt 0pt 15.6pt 22.1pt;
          text-align: justify;
          text-indent: -22.1pt;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >1.7.5</span
        ><span style="font: 7pt 'Times New Roman'"> </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >当授权用户申请云仓时，需要收集云仓申请人姓名、云仓申请人电话号码。当授权用户本身作为云仓仓主时，我们需要验证用户的身份。为此我们需要收集云仓仓主联系人姓名、云仓仓主联系人电话号码、</span
        ><span
          style="
            font-family: 宋体;
            font-size: 10.5pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >云仓仓主身份证号码、云仓仓主身份证图片</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >，以完成云仓仓主认证。</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >上述所有加粗并标注下划线的字段为法定的敏感个人信息。该信息的收集系企业用户为了实现云仓仓主认证目的所必需。</span
        ><a name="_Hlk170813306"
          ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
            >如果授权用户不提供此信息，则我们无法帮助其所属的企业用户实现前述目的。</span
          ></a
        >
      </p>
      <p
        style="
          margin: 15.6pt 0pt 15.6pt 22.1pt;
          text-align: justify;
          text-indent: -22.1pt;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >1.7.6</span
        ><span style="font: 7pt 'Times New Roman'"> </span
        ><span style="-aw-bookmark-end: _Hlk170813306"></span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >当授权用户发布仓库时，需要收集仓库联系人姓名、仓库联系人电话号码、仓库联系人电子邮箱，以便对您发布仓库感兴趣的商家与您取得联系。</span
        >
      </p>
      <p
        style="
          margin: 15.6pt 0pt 15.6pt 22.1pt;
          orphans: 0;
          text-align: justify;
          text-indent: -22.1pt;
          widows: 0;
        "
      >
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >1.7.7</span
        ><span style="font: 7pt 'Times New Roman'"> </span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: normal"
          >当授权用户开通网商支付能力后使用支付功能时，需要收集个人的</span
        ><span
          style="
            font-family: 宋体;
            font-size: 10.5pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >网商银行账号、支付流水记录</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: normal"
          >。</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >上述所有加粗并标注下划线的字段为法定的敏感个人信息。该信息的收集系企业用户为了实现网商支付目的所必需。</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >如果授权用户不提供此信息，则我们无</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >法帮助其所属的企业用户实现前述目的。</span
        >
      </p>
      <p
        style="
          margin: 15.6pt 0pt 15.6pt 22.1pt;
          text-align: justify;
          text-indent: -22.1pt;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >1.7.8</span
        ><span style="font: 7pt 'Times New Roman'"> </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >授权用户在浏览云仓平台以及供销平台时，可以点击收藏感兴趣的仓库、需求、供应商或货品信息。我们会将您收藏的仓库以及需求信息列为云仓收藏列表，将您收藏的供应商、货品列为供销平台收藏列表。</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >对于上述个人信息，原则上由企业用户负责向</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >您</span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >告知个人信息收集、使用的目的、方式和范围，如您对相关内容有疑问或主张相关的个人信息权益，您知悉并理解您可以联系企业用户或管理员用户处理。</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >特别提示您注意，如信息无法单独或结合其他信息识别到您的个人身份，其不属于法律意义上您的个人信息；当您的信息可以单独或结合其他信息识别到您的个人身份时或我们将无法与任何特定个人信息建立联系的数据与其他您的个人信息结合使用时，这些信息在结合使用期间，将作为您的个人信息按照本隐私政策处理与保护。</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 12pt;
            font-weight: bold;
          "
          >2. </span
        ><span style="font-family: 宋体; font-size: 12pt; font-weight: bold"
          >我们如何使用</span
        ><span
          style="
            font-family: 'Times New Roman';
            font-size: 12pt;
            font-weight: bold;
          "
          >Cookie</span
        ><span style="font-family: 宋体; font-size: 12pt; font-weight: bold"
          >和同类技术</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >2.1 </span
        ><a name="_Hlk170843356"
          ><span style="font-family: 宋体; font-size: 10.5pt">我们使用</span
          ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
            >Cookie</span
          ><span style="font-family: 宋体; font-size: 10.5pt"
            >和其他类似技术，以记录您的用户身份、分析您使用本服务的情况以向您提供个性化的服务体验。当您使用本服务时，我们可能会使用相关技术向您的设备发送一个或多个</span
          ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
            >Cookie</span
          ><span style="font-family: 宋体; font-size: 10.5pt"
            >或匿名标识符，以收集和存储您访问、使用本服务时的信息。我们承诺，不会将</span
          ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
            >Cookie</span
          ><span style="font-family: 宋体; font-size: 10.5pt"
            >用于本隐私政策所述目的之外的任何其他用途</span
          ></a
        ><span style="font-family: 宋体; font-size: 10.5pt">。</span>
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >2.2 </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >大多数浏览器均为用户提供了清除浏览器缓存数据的功能，您可以在浏览器设置功能中进行相应的数据清除操作。如您进行清除，您可能无法使用由我们提供的、依赖于</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >Cookie</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >的服务或相应功能。</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 12pt;
            font-weight: bold;
          "
          >3. </span
        ><span style="font-family: 宋体; font-size: 12pt; font-weight: bold"
          >数据处理过程中涉及的合作方以及转移、公开个人信息</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >3</span
        ><span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >.1 </span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >数据处理过程中涉及的合作方</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt"
          >我们会根据企业用户的指示，将企业用户的数据提供给企业用户指示的第三方，但请您注意，此类第三方并非我们选定，我们本身不会将您的个人信息提供给第三方。在这种情况下，我们会尽合理审慎义务，测试第三方的数据接口安全，确保企业用户数据的安全传输。</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >3</span
        ><span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >.2 </span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >转移</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt"
          >随着我们业务的持续发展，我们将有可能进行合并、收购、资产转让，您的个人信息有可能因此而被转移。在发生前述变更时，我们将按照法律法规及不低于本隐私政策所要求的安全标准继续保护或要求个人信息的继受方继续保护您的个人信息，否则我们将要求继受方重新征得您的授权同意。</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >3</span
        ><span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >.3 </span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >公开</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt"
          >我们不会公开您的信息，除非遵循国家法律法规规定、基于您的主动选择或者获得您的同意。我们公开您的个人信息会采用符合行业内标准的安全保护措施。</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >3</span
        ><span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >.4 </span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >依法豁免征得同意提供、公开的个人信息</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt"
          >请您理解，在下列情形中，根据法律法规及国家标准，我们向合作方或第三方提供、公开您的个人信息无需征得您的授权同意：</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <a name="_Hlk170843489"
          ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
            >a. </span
          ><span style="font-family: 宋体; font-size: 10.5pt"
            >与个人信息控制者履行法律法规规定的义务相关的；</span
          ></a
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >b. </span
        ><span style="font-family: 宋体; font-size: 10.5pt">与国家安全、</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >国防安全直接相关的；</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >c. </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >与公共安全、公共卫生、</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >重大公共利益直接相关的；</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >d. </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >与刑事侦查、起诉、</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >审判和判决执行等直接相关的；</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >e. </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >出于维护个人信息主体或其他个人的生命、</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >财产等重大合法权益但又很难得到本人授权同意的；</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >f. </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >个人信息主体自行向社会公众公开的个人信息；</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >g. </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</span
        ><span style="-aw-bookmark-end: _Hlk170843489"></span>
      </p>
      <p style="margin: 5pt 0pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 12pt;
            font-weight: bold;
          "
          >4</span
        ><span
          style="
            font-family: 'Times New Roman';
            font-size: 12pt;
            font-weight: bold;
          "
          >. </span
        ><span style="font-family: 宋体; font-size: 12pt; font-weight: bold"
          >我们如何存储个人信息</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >4</span
        ><span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >.1 </span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >存储地点</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt"
          >我们依照法律法规的规定，在中国境内运营过程中收集和产生的个人信息存储于中华人民共和国境内。</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >4</span
        ><span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >.2 </span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >存储期限</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">4</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >.2.1 </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >您在使用本服务期间，我们将持续保存您的个人信息，保存期限将以不超过提供服务所必须的期间为原则。如我们停止运营本服务、您申请注销账号、主动删除个人信息或超出必要期间后，我们将在合理期限内依照所适用的法律对所持有的您的个人信息进行删除或匿名化处理。但以下情况除外：</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">a.</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >遵从法律法规有关信息留存的要求（例如：《网络安全法》规定：采取监测、记录网络运行状态、网络安全事件的技术措施，并按照规定留存相关的网络日志不少于六个月）。</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">b.</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >出于财务、审计、争议解决等目的需要合理延长期限的。</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">c.</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >企业用户作为个人信息处理者对相关信息有其他处理需求的。</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">4</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >.2.2 </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >您知悉并理解，如您对我们根据企业用户指示处理个人信息有任何疑问或主张相关个人信息权益的，您应当联系企业用户或管理员用户处理。</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 12pt;
            font-weight: bold;
          "
          >5</span
        ><span
          style="
            font-family: 'Times New Roman';
            font-size: 12pt;
            font-weight: bold;
          "
          >. </span
        ><span style="font-family: 宋体; font-size: 12pt; font-weight: bold"
          >我们如何保护个人信息的安全</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >5</span
        ><span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >.1 </span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >安全管理制度和安全技术措施</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">5</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >.1.1 </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >我们非常重视个人信息的安全，将努力采取合理的安全措施来保护您的个人信息，确保我们的个人信息处理活动符合法律、行政法规或依法可适用的其他制度的要求，并防止未经授权的访问以及个人信息泄露、篡改、丢失。</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">5</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >.1.2 </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >基于适用的法律法规要求和相关安全标准，我们建立了高标准的个人信息保护管理体系，并实施了安全技术措施来确保个人信息处理全生命周期中的安全性与合规性，充分保障您的个人隐私。我们的网络服务采取了传输层安全协议等加密技术，确保您的数据在网络传输过程的安全。</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">5</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >.1.3 </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >我们采用严格的数据处理权限控制，避免数据被违规使用。我们采用打码屏蔽等去标识化技术的多种数据脱敏方式增强个人信息在使用中的安全性。同时，我们采用行业广泛应用的加密技术对您的个人信息进行加密保存，并通过数据隔离技术进行隔离。我们始终落实该等技术措施和组织管理方式，并可能不时加以修订完善以提升系统的整体安全性。</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">5</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >.1.4 </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >在发生危害网络安全的事件时，我们会按照网络安全事件应急预案，及时采取相应的补救措施。如果我们的物理设施或技术防护措施遭到破坏，导致您的个人信息被泄露、非法提供或滥用，造成您的合法权益受损，我们将严格依照法律的规定承担相应的责任。</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">5</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >.1.5 </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >在我们获悉发生了您的个人信息不幸被泄露、非法提供或滥用的个人信息安全事件后，我们将按照法律法规的要求及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以推送通知的方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >5</span
        ><span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >.2 </span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >安全提示</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">5</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >.2.1 </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保个人信息的安全性。</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">5</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >.2.2 </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >请您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码等个人信息透露给他人。</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">5</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >.2.3 </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >您一旦浏览或使用其他网站、服务及内容资源，我们将没有能力和直接义务保护您在使用第三方产品过程中提交的任何个人信息，无论您登录、浏览或使用上述软件、网站是否基于本服务的链接或引导。</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 12pt;
            font-weight: bold;
          "
          >6</span
        ><span
          style="
            font-family: 'Times New Roman';
            font-size: 12pt;
            font-weight: bold;
          "
          >. </span
        ><span style="font-family: 宋体; font-size: 12pt; font-weight: bold"
          >管理您的个人信息</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt"
          >我们非常重视您对个人信息的管理，并尽全力保护您对于您个人信息的查阅、复制、更正、补充、删除、撤回同意授权、注销账号、投诉举报以及设置隐私功能等权利，以使您有能力保障您的隐私和信息安全。</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt"
          >我们在不同的版本或操作系统中提供的管理方式的路径可能会有差异，请以实际为准。</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >6</span
        ><span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >.1 </span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >查询、复制、更正、补充</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >a. </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >如果您是授权用户，您可以：</span
        >
      </p>
      <p
        style="
          margin: 5pt 0pt 5pt 22pt;
          text-align: justify;
          text-indent: -22pt;
        "
      >
        <span style="font-family: Wingdings; font-size: 10.5pt"></span
        ><span style="font: 7pt 'Times New Roman'"
          >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span style="font-family: 宋体; font-size: 10.5pt">通过“分销</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">-</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >个人资料”，查询、复制、</span
        ><span style="font-family: 宋体; font-size: 10.5pt">更正、补充</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >您的分销商注册用户姓名、分销商联系人相关信息、卖家地址；</span
        >
      </p>
      <p
        style="
          margin: 5pt 0pt 5pt 22pt;
          text-align: justify;
          text-indent: -22pt;
        "
      >
        <span style="font-family: Wingdings; font-size: 10.5pt"></span
        ><span style="font: 7pt 'Times New Roman'"
          >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >通过“系统设置-公司名片”，查询、复制</span
        ><span style="font-family: 宋体; font-size: 10.5pt">、</span
        ><span style="font-family: 宋体; font-size: 10.5pt">更正、补充</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >您的供应商联系人相关信息、售后退货联系人相关信息；</span
        >
      </p>
      <p
        style="
          margin: 5pt 0pt 5pt 22pt;
          text-align: justify;
          text-indent: -22pt;
        "
      >
        <span style="font-family: Wingdings; font-size: 10.5pt"></span
        ><span style="font: 7pt 'Times New Roman'"
          >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >通过“云仓平台-会员中心-实名认证”，查询、复制</span
        ><span style="font-family: 宋体; font-size: 10.5pt">、</span
        ><span style="font-family: 宋体; font-size: 10.5pt">更正、补充</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >您的云仓仓主联系人相关信息；</span
        >
      </p>
      <p
        style="
          margin: 5pt 0pt 5pt 22pt;
          text-align: justify;
          text-indent: -22pt;
        "
      >
        <span style="font-family: Wingdings; font-size: 10.5pt"></span
        ><span style="font: 7pt 'Times New Roman'"
          >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >通过“云仓平台-会员中心-需求列表/仓库列表-查看合作”，查询、复制</span
        ><span style="font-family: 宋体; font-size: 10.5pt">、</span
        ><span style="font-family: 宋体; font-size: 10.5pt">更正、补充</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >您的云仓申请人相关信息；</span
        >
      </p>
      <p
        style="
          margin: 5pt 0pt 5pt 22pt;
          text-align: justify;
          text-indent: -22pt;
        "
      >
        <span style="font-family: Wingdings; font-size: 10.5pt"></span
        ><span style="font: 7pt 'Times New Roman'"
          >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span style="font-family: 宋体; font-size: 10.5pt">通过“分销供货</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">-</span
        ><span style="font-family: 宋体; font-size: 10.5pt">分销资金管理</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">-</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >我的账户管理”，查询、复制网商账户和支付流水信息；</span
        >
      </p>
      <p
        style="
          margin: 5pt 0pt 5pt 22pt;
          text-align: justify;
          text-indent: -22pt;
        "
      >
        <span style="font-family: Wingdings; font-size: 10.5pt"></span
        ><span style="font: 7pt 'Times New Roman'"
          >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span style="font-family: 宋体; font-size: 10.5pt">通过“云仓平台</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">-</span
        ><span style="font-family: 宋体; font-size: 10.5pt">会员中心</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">-</span
        ><span style="font-family: 宋体; font-size: 10.5pt">资源</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">-</span
        ><span style="font-family: 宋体; font-size: 10.5pt">我的收藏</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">-</span
        ><span style="font-family: 宋体; font-size: 10.5pt">仓库收藏</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">/</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >需求收藏”，查询、复制云仓收藏列表、供销平台收藏列表；</span
        >
      </p>
      <p
        style="
          margin: 5pt 0pt 5pt 22pt;
          text-align: justify;
          text-indent: -22pt;
        "
      >
        <span style="font-family: Wingdings; font-size: 10.5pt"></span
        ><span style="font: 7pt 'Times New Roman'"
          >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
        ><span style="font-family: 宋体; font-size: 10.5pt">通过“数据看板</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">-</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >访客数据”，查询访客浏览记录。</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">b</span
        ><span style="font-family: 宋体; font-size: 10.5pt">．</span
        ><span style="font-family: 宋体; font-size: 10.5pt"> </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >您也可以联系管理员用户，查询、复制、更正、补充自己的基本信息，由管理员用户处理。</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >6</span
        ><span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >.2 </span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >撤销、删除</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt"
          >你可以直接在设备操作系统中自主开启或关闭相关系统权限，改变同意范围或撤回你的授权。撤回授权后我们将不再收集与该权限相关信息。</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt"
          >您可以电话或窗口联系我们的售后客服</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">/</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >销售，或由管理员用户代您告知售后客服申请撤销或删除您的个人信息。客服收集您的相关情况后会辅助您提出撤销以及删除申请，并在我们通过内部审核后向您反馈撤销或删除情况。</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt"
          >当您撤回同意后，我们将不再处理相应的个人信息。但请您理解，特定的业务功能和服务将需要您的信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供对应的功能和服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响我们此前基于您的授权而开展的个人信息处理。</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt"
          >在以下情况下，我们会删除您的个人信息，或按照适用的相关法律、法规及标准匿名化处理您的信息：</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt">（</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">1</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >）您联系管理员用户主动注销账号；</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt">（</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">2</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >）如果我们终止服务及运营；</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt">（</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">3</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >）如果我们处理个人信息的行为违反法律法规或</span
        ><span style="font-family: 宋体; font-size: 10.5pt">与您的约定，</span
        ><a name="_Hlk170843540"
          ><span style="font-family: 宋体; font-size: 10.5pt">您可以通过</span
          ><span style="font-family: 宋体; font-size: 10.5pt">第</span
          ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
            >8</span
          ><span style="font-family: 宋体; font-size: 10.5pt">节</span
          ><span style="font-family: 宋体; font-size: 10.5pt"
            >的联系方式联系我们删除</span
          ></a
        ><span style="font-family: 宋体; font-size: 10.5pt">；</span>
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt">（</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">4</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >）依据相关法律法规及国家标准的规定，或依据政府部门、司法机关的要求必须予以删除，或您的信息存储期限到期。</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >6</span
        ><span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >.3 </span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >注销账号</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">6</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >.3.1 </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >若您是授权用户，退出所在组织、被管理员用户操作离职或您所在组织解散团队的，可以联系企业用户或管理员用户实现注销组织身份账号。</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">6</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >.3.2 </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >您知悉并理解，注销账号的行为是不可逆的行为，在您的账号被注销后，我们将删除有关您的相关信息或进行匿名化处理，但法律法规另有规定或根据企业用户需要就企业用户使用的数据另行处理的除外。</span
        >
      </p>
      <p style="margin: 5pt 0pt">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >6</span
        ><span
          style="
            font-family: 'Times New Roman';
            font-size: 10.5pt;
            font-weight: bold;
          "
          >.4 </span
        ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
          >响应您的上述请求</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt"
          >您可以通过前述方式实现部分个人信息</span
        ><a name="_Hlk170846808"
          ><span style="font-family: 宋体; font-size: 10.5pt"
            >权利，包括但不限于</span
          ></a
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >查阅、复制、更正、补充、删除、注销账户等，如果您无法通过前述路径行使您的个人信息主体权利</span
        ><a name="_Hlk170846813"
          ><span style="font-family: 宋体; font-size: 10.5pt"
            >或申请行使其他权利</span
          ></a
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >，您可以与您的管理员用户进行联系，我们将在</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >15</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >个工作日之内响应您的管理员用户代您提出的请求。如果您是管理员用户，您可以通过第</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">8</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >节的联系方式联系我们，我们将在</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >15</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >个工作日之内响应您的请求。</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt"
          >如前所述，我们还会根据企业用户指示，处理授权用户向我们提交的个人信息。如果您希望针对这部分个人信息行使适用的法律所规定的权利，建议您直接咨询管理员用户。如果您直接向我们提出申请，您需要向我们提供您的具体信息，我们会将您的申请转交给对应企业用户的管理员用户处理。具体的处理结果以管理员用户的处理为准。</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 12pt;
            font-weight: bold;
          "
          >7</span
        ><span
          style="
            font-family: 'Times New Roman';
            font-size: 12pt;
            font-weight: bold;
          "
          >.</span
        ><span style="font-family: 宋体; font-size: 12pt; font-weight: bold"
          >隐私政策的修订和通知</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">7</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >.1 </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >为了给您提供更好的服务，本服务将不时更新与变化，我们会适时对本隐私政策进行修订，这些修订构成本隐私政策的一部分并具有等同于本隐私政策的效力，未经您明确同意，我们不会削减您依据当前生效的本隐私政策所应享受的权利。</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 'Times New Roman'; font-size: 10.5pt">7</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >.2 </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >本隐私政策更新后，我们会发出更新版本，并在更新后的条款生效前通过适当的方式提醒您更新的内容，以便您及时了解本隐私政策的最新版本。如果您在本隐私政策更新之后继续使用本服务，即视为您接受更新后的隐私政策。</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 12pt;
            font-weight: bold;
          "
          >8</span
        ><span
          style="
            font-family: 'Times New Roman';
            font-size: 12pt;
            font-weight: bold;
          "
          >.</span
        ><span style="font-family: 宋体; font-size: 12pt; font-weight: bold"
          >联系我们</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt"
          >供销平台产品及服务的运营者是北京掌上先机网络科技有限公司</span
        ><span style="font-family: 宋体; font-size: 10.5pt">及关联公司</span
        ><span style="font-family: 宋体; font-size: 10.5pt">，</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >注册地址为北京市昌平区生命科学园医科路</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">9</span
        ><span style="font-family: 宋体; font-size: 10.5pt">号院</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">4</span
        ><span style="font-family: 宋体; font-size: 10.5pt">号楼三层</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >303-78</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >。与本隐私政策相关的任何疑问、意见或请求，您可以通过</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >400-010-1039</span
        ><span style="font-family: 宋体; font-size: 10.5pt">转</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">2</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"> </span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >联系我们。一般情况下，我们会在收到您相关联系信息并核实您身份后的</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >15</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >个工作日内回复。</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span
          style="
            font-family: 'Times New Roman';
            font-size: 12pt;
            font-weight: bold;
          "
          >9.</span
        ><span style="font-family: 宋体; font-size: 12pt; font-weight: bold"
          >未成年人保护</span
        >
      </p>
      <p style="margin: 5pt 0pt; text-align: justify">
        <span style="font-family: 宋体; font-size: 10.5pt"
          >我们非常重视对未成年人个人信息的保护。我们的平台仅面向成年人，未满</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt"
          >18</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >周岁的未成年人不应创建自己的账户或向我们提供任何个人信息，如果我们发现在未事先获得父母或监</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >护人同意的情况下收集了未成年人的个人信息，我们将尽快删除相关数据。若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过第</span
        ><span style="font-family: 'Times New Roman'; font-size: 10.5pt">8</span
        ><span style="font-family: 宋体; font-size: 10.5pt"
          >节中的联系方式与我们联系。</span
        >
      </p>
    </div>
  </div>
</template>
